import { allowance } from "@bracket/contractor-next/erc20";
import type { TokenIdentifier, VaultAddress, } from "@bracket/types";
import { wagmiConfig as config } from "@wagmiconfig";



export declare type GetVaultAllowanceProps = {
	vault: VaultAddress;
	token: TokenIdentifier;
};



/**
 * Gets the current allowance for a vault to spend a user's tokens
 * @param {GetVaultAllowanceProps} props - The allowance check parameters
 * @param {ContractAddress} props.vault - The vault address to check allowance for
 * @param {TokenIdentifier} props.token - The token identifier to check allowance for
 * @returns {Promise<bigint>} The current allowance amount in wei, or 0 if the check fails
 */
export const getVaultAllowance = async ({
	vault,
	token,
}: GetVaultAllowanceProps): Promise<bigint> => {
	try {
		const spender = vault;
		return allowance({ token, spender, config, });
	}
	catch (err) {
		console.error(err);
		return BigInt(0);
	}
};
